// extracted by mini-css-extract-plugin
module.exports = {"heading":"_flRvYly _1d0WKk0g","body":"_3iXKbFnm _1d0WKk0g"};